import { APIGet, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";
import { ILeague } from "redux/reducers/models/league";

const apiVersion = "2024-04";
const adminType = "guest";
const baseLeagueUrl = "/" + apiVersion + "/" + adminType + "/league";

interface IGetLeague {
  id?: number;
  facility_id?: number;
  handle?: string;
  offset?: number;
  limit?: number;
  year?: number;
  month?: number;
  timeframe?: "upcoming" | "past";
  search?: string;
}

export async function GetGuestLeague(
  params: IGetLeague,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IAPIResponse<Array<ILeague>>> {
  return await APIGet(baseLeagueUrl, params, useGlobalLoader, token);
}

export interface IGuestSponsorship {
  id: number;
  source: string;
}

export async function GetGuestLeagueSponsorship(
  params: { league_id: number },
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IAPIResponse<IGuestSponsorship[]>> {
  return await APIGet(baseLeagueUrl + "/sponsorship", params, useGlobalLoader, token);
}

export async function GetGuestOnlineStoreLeagues(
  params: Pick<IGetLeague, "id" | "facility_id" | "handle">,
  useGlobalLoader: boolean,
  token?: CancelToken,
): Promise<IAPIResponse<Array<ILeague>>> {
  return await APIGet(baseLeagueUrl + "/online-store", params, useGlobalLoader, token);
}
